<template>
  <div class="home">
    <el-container class="el-container">
      <el-header style="position: relative">
        <!-- logo -->
        <img class="logo" src="../assets/logo.png" />
      </el-header>
      <el-container class="el-nav">
        <el-aside width="200px">
          <el-row class="tac">
            <el-col :span="24">
              <el-menu
                :default-active="activeIndex"
                class="el-menu-vertical-demo"
                text-color="#fff"
                active-text-color="#000"
                router
              >
                <el-menu-item
                  :class="{
                    active: activeIndex === item.path,
                    noactive: activeIndex !== item.path,
                  }"
                  :index="item.path"
                  v-for="item in leftList"
                  :key="item.id"
                  @click="handclick(item.path)"
                >
                  <span style="text-align: center">{{ item.title }}</span>
                  <img
                    :src="
                      require(`@/assets/${
                        activeIndex === item.path ? 'arrows1.png' : 'arrows.png'
                      }`)
                    "
                    alt=""
                    style="
                      width: auto;
                      height: 28px;
                      position: absolute;
                      right: 15px;
                      top: 50%;
                      transform: translateY(-50%);
                    "
                  />
                </el-menu-item>
              </el-menu>
            </el-col>
          </el-row>
        </el-aside>
        <el-main ref="contentToExport" class="uppdf">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { AuthorInfo } from "../api/user";
export default {
  data() {
    return {
      user_id: "",
      leftList: [
        { id: 1, title: "我的基本信息", path: "/mymessage" },
        { id: 2, title: "上传专辑信息", path: "/uploadmusic" },
        { id: 3, title: "我上传的专辑", path: "/myupload" },
        { id: 4, title: "对公账户打款", path: "/remittance" },
      ],
      activeIndex: "", // 初始化激活项，为空以便在 created 或 mounted 中设置
    };
  },
  watch: {
    // 更新 activeIndex 以匹配当前路由
    $route(to) {
      this.activeIndex = to.path;
    },
  },
  mounted() {
    this.handclick("/mymessage");
  },
  methods: {
    async getAuthorInfo() {
      const { data } = await AuthorInfo();
      if (data === null) {
        this.user_id = "";
      } else {
        this.user_id = data.user_id;
      }
    },
    async handclick(path) {
      if (path == "/uploadmusic") {
        await this.getAuthorInfo(); // 等待 getAuthorInfo 完成
        if (this.user_id == "") {
          console.log("请先填写基本信息", this.user_id);
          this.$message({
            message: "请先填写基本信息",
            type: "warning",
          });
          this.$router.replace({ path: "/mymessage" });
        } else {
          if (this.$route.path !== path) {
            this.$router.push(path);
          }
        }
      } else {
        if (this.$route.path !== path) {
          this.$router.push(path);
        }
      }
    },
    exportToPDF() {
      this.$nextTick(() => {
        // 添加一个延迟确保 DOM 元素加载完成
        setTimeout(() => {
          const element = this.$refs.contentToExport;
          if (!element) {
            console.error("Element not found!");
            return;
          }
          html2canvas(element)
            .then((canvas) => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jsPDF("p", "mm", "a4");
              const imgWidth = 210; // A4 width in mm
              const imgHeight = (canvas.height * imgWidth) / canvas.width;
              const pageHeight = 295; // A4 height in mm
              let heightLeft = imgHeight;
              let position = 0;

              pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
              heightLeft -= pageHeight;

              while (heightLeft >= 0) {
                position -= pageHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
              }

              pdf.save("我的专辑.pdf");
            })
            .catch((error) => {
              console.error("Error capturing element:", error);
            });
        }, 500); // 适当的时间延迟以确保视图准确
      });
    },
  },
  created() {
    // 检查是否从登录页面跳转过来
    if (this.$route.query.fromLogin) {
      this.activeIndex = this.leftList[0].path;
      this.$router.push(this.leftList[0].path);
    } else {
      // 如果不是从登录页面跳转过来，使用当前路由路径
      this.activeIndex = this.$route.path;
    }
  },
};
</script>

<style scoped lang="scss">
.home {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.el-header {
  height: 12.7% !important;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-container {
  background: url("../assets/home/homebgimg.png") no-repeat;
  background-position: 100% 70%;
  background-size: 110% auto;
  width: 100vw;
  height: 100vh;

  .el-nav {
    height: 87.3%;
  }
}

.el-aside {
  width: 14% !important;
  color: #333;
  background: url("../assets/home/homebgimg.png") no-repeat !important;
  background-position: 24% 94%;
  background-size: 450% auto;
}

.el-main {
  background: #fff;
  height: 87.3vh;
  flex: 1;
  overflow-y: auto;
  padding: 0;
  color: #333;
  overflow: hidden;
}


.el-menu {
  background-color: transparent;
}

.el-menu-item {
  margin: 10px 0;
  font-size: 18px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    margin-right: 40px;
  }
}

.el-menu-vertical-demo .el-menu-item.active {
  background-color: #fff;
  color: #000;
  height: 100px;
  line-height: 100px;
  margin: 0;
  font-weight: 600;
}

.el-menu-vertical-demo .el-menu-item.noactive {
  background-color: #a52424;
  color: #fff;
  height: 80px;
  line-height: 80px;
}

.export {
  width: 220px;
  height: 40px;
  background: #a52424;
  color: #fff;
  font-size: 18px;
  border-radius: 50px;
  position: absolute;
  top: 40px;
  right: 50px;
  border: none;
}
.logo {
  width: 11.2vw;
  height: 2.1vw;
  position: absolute;
  top: 1.6vw;
  left: 1.4vw;
}
</style>